import { AbstractControl } from '@angular/forms';
import { ItemBaseModel } from '@libs/form/models';
import { ConditionEvaluator } from '../evaluator';
import { StateHandler } from './state.handler';

export abstract class StateHandlerBase implements StateHandler {
  public constructor(
    protected readonly evaluator: ConditionEvaluator,
    protected readonly element: ItemBaseModel,
    protected readonly control?: AbstractControl,
  ) {
  }

  public abstract handle(): void;
}
